var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarViewIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1271_10166)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5634 5.5H26.5842V7.33333H29.3342V27.5H3.66755V7.33333H6.41755V5.5H3.43839C3.2241 5.50358 3.01263 5.54934 2.81603 5.63467C2.61944 5.71999 2.44158 5.84321 2.29261 5.99728C2.14364 6.15136 2.02649 6.33327 1.94784 6.53263C1.86919 6.73198 1.83058 6.94489 1.83422 7.15917V27.6742C1.83058 27.8884 1.86919 28.1013 1.94784 28.3007C2.02649 28.5001 2.14364 28.682 2.29261 28.8361C2.44158 28.9901 2.61944 29.1133 2.81603 29.1987C3.01263 29.284 3.2241 29.3298 3.43839 29.3333H29.5634C29.7777 29.3298 29.9891 29.284 30.1857 29.1987C30.3823 29.1133 30.5602 28.9901 30.7092 28.8361C30.8581 28.682 30.9753 28.5001 31.0539 28.3007C31.1326 28.1013 31.1712 27.8884 31.1676 27.6742V7.15917C31.1712 6.94489 31.1326 6.73198 31.0539 6.53263C30.9753 6.33327 30.8581 6.15136 30.7092 5.99728C30.5602 5.84321 30.3823 5.71999 30.1857 5.63467C29.9891 5.54934 29.7777 5.50358 29.5634 5.5Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.33398 12.834H9.16732V14.6673H7.33398V12.834Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.834 12.834H14.6673V14.6673H12.834V12.834Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.334 12.834H20.1673V14.6673H18.334V12.834Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.834 12.834H25.6673V14.6673H23.834V12.834Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.33398 17.416H9.16732V19.2493H7.33398V17.416Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.834 17.416H14.6673V19.2493H12.834V17.416Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.334 17.416H20.1673V19.2493H18.334V17.416Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.834 17.416H25.6673V19.2493H23.834V17.416Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.33398 22H9.16732V23.8333H7.33398V22Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.834 22H14.6673V23.8333H12.834V22Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.334 22H20.1673V23.8333H18.334V22Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.834 22H25.6673V23.8333H23.834V22Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.16667 9.16732C9.40978 9.16732 9.64294 9.07074 9.81485 8.89883C9.98676 8.72692 10.0833 8.49377 10.0833 8.25065V2.75065C10.0833 2.50754 9.98676 2.27438 9.81485 2.10247C9.64294 1.93056 9.40978 1.83398 9.16667 1.83398C8.92355 1.83398 8.69039 1.93056 8.51849 2.10247C8.34658 2.27438 8.25 2.50754 8.25 2.75065V8.25065C8.25 8.49377 8.34658 8.72692 8.51849 8.89883C8.69039 9.07074 8.92355 9.16732 9.16667 9.16732Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8327 9.16732C24.0758 9.16732 24.309 9.07074 24.4809 8.89883C24.6528 8.72692 24.7493 8.49377 24.7493 8.25065V2.75065C24.7493 2.50754 24.6528 2.27438 24.4809 2.10247C24.309 1.93056 24.0758 1.83398 23.8327 1.83398C23.5896 1.83398 23.3564 1.93056 23.1845 2.10247C23.0126 2.27438 22.916 2.50754 22.916 2.75065V8.25065C22.916 8.49377 23.0126 8.72692 23.1845 8.89883C23.3564 9.07074 23.5896 9.16732 23.8327 9.16732Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.916 5.5H21.0827V7.33333H11.916V5.5Z",
    fill: "#222222"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1271_10166"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarViewIcon);
export default __webpack_public_path__ + "static/media/calendar-view-icon.252e001ee5e58fb83a8b78ca7e831bc5.svg";
export { ForwardRef as ReactComponent };